import { environment } from './../../../../../environment/environment';
import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { NgxSpinnerService } from 'ngx-spinner';
import { EvaluationService } from '@core/services/evaluation/evaluation.service';
import { Subject, takeUntil } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { serverError } from '@core/models/messages';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { LocalStorageService } from '@core/services/local-storage.service';


@Component({
  selector: 'app-details-eval-wegestu',
  templateUrl: './details-eval-wegestu.component.html',
  styleUrls: ['./details-eval-wegestu.component.css'],
})
export class DetailsEvalWegestuComponent {

  private unsubscribeAll: Subject<void> = new Subject();
  
  id = this.activatedRoute.snapshot.params['id'];
  modalRef?: BsModalRef;
  comments: { [key: number]: { [key: number]: string } } = {};
  starsArray: any[] = [];
  ratings: any = [];
  selectedRating: number = 0;
  selectedStars: any = [];
  evaluationData: any;
  evaluationDetailsArray: any[] = [];
  currentUser: any;
  currentConversationUserId: number | null = null;
  profil_image: any;
  last_name: any;
  nomconsultant: any;
  url: string = environment.baseUrl;
  profil_id: any;
  company: any;

  evaluationDetail: any
  
  formPV: FormGroup = this.createPVForm();
  toolbarOptions = [
    ['bold', 'italic', 'underline'], // toggled buttons
    [{ header: 1 }, { header: 2 }], // custom button values
    [{ list: 'ordered' }, { list: 'bullet' }],
    [{ indent: '-1' }, { indent: '+1' }],
    [{ color: [] }, { background: [] }], // outdent/indent
    ['clean'], // remove formatting button
  ];

  constructor(
    private activatedRoute: ActivatedRoute,
    private spinner: NgxSpinnerService,
    private router: Router,
    private evaluationService : EvaluationService,
    private toastr: ToastrService,
    private formBuilder: FormBuilder,
    private localStorageService: LocalStorageService,
  ) {}
  ngOnInit() {
    this.currentUser = JSON.parse(this.localStorageService.getData('UserInfo') || '{}');
    this.getTemplateDetails();
  }

  closeModal() {
    this.modalRef?.hide();
    this.formPV.reset()
  }

  getTemplateDetails(){
      this.spinner.show();
  
      this.evaluationService
          .getSentEvaluationDetails(this.id)
          .pipe(takeUntil(this.unsubscribeAll))
          .subscribe({
            next: (res) => {
              if (res.status == 200) {
                this.evaluationDetail = res.data

                if(this.evaluationDetail?.evalPvEsn[0]?.report){
                  this.formPV.patchValue({ report: this.evaluationDetail?.evalPvEsn[0]?.report });
                }
                this.spinner.hide();
              }
            },
            error: (err) => {
              this.spinner.hide();
              if (err?.error) {
                this.toastr.error(serverError);
              }
            },
          });
    }

navigateToEvalList() {
    this.router.navigate([
      '/evaluation/list',
    ]);
  }

createPVForm(data?: any) {
    return this.formBuilder.group({
      evaluation_esn_sent_id: [this.id],
      report: [data?.report, Validators.required],
    });
  }

isSendEnable() : boolean{
  return this.evaluationDetail?.evalPvEsn?.length > 0
}

savePV(){
  if (this.formPV.invalid) return;
 
    this.formPV.patchValue({ evaluation_esn_sent_id: this.id });
    this.spinner.show();
    this.evaluationService
      .savePv(this.formPV.value)
      .pipe(takeUntil(this.unsubscribeAll))
      .subscribe({
        next: (res) => {
          if (res.status == 200 || res.status == 201) {
            this.closeModal();
            this.getTemplateDetails()
            this.spinner.hide();
            this.toastr.success("Le compte rendu a été enregistré avec succès.");
          }
        },
        error: (err) => {
          this.spinner.hide();
          if (err?.error) {
            this.toastr.error(serverError);
          }
        },
      });
}

updatePV(){
  if (this.formPV.invalid) return;
 
    this.formPV.patchValue({ evaluation_esn_sent_id: this.id });
    this.spinner.show();
    this.evaluationService
      .updatePv(this.evaluationDetail?.evalPvEsn[0]?.id, this.formPV.value)
      .pipe(takeUntil(this.unsubscribeAll))
      .subscribe({
        next: (res) => {
          if (res.status == 200 || res.status == 201) {
            this.closeModal();
            this.getTemplateDetails()
            this.spinner.hide();
            this.toastr.success("Le compte rendu a été modifié avec succès.");
          }
        },
        error: (err) => {
          this.spinner.hide();
          if (err?.error) {
            this.toastr.error(serverError);
          }
        },
      });
}

sendPV(){
  this.spinner.show();
  this.evaluationService
    .sendPv(this.evaluationDetail?.evalPvEsn[0].id)
    .pipe(takeUntil(this.unsubscribeAll))
    .subscribe({
      next: (res) => {
        if (res.status == 200) {
          this.spinner.hide();
          this.router.navigateByUrl('/evaluation/list');
          this.toastr.success("Le compte rendu a été envoyé avec succès.");
        }
      },
      error: (err) => {
        this.spinner.hide();
        if (err?.error) {
          this.toastr.error(serverError);
        }
      },
    });
}

isEvalOwner() : boolean{   
  return this.currentUser?.id === this.evaluationDetail?.sender?.id
}

}
